import { render } from "./Steps4.vue?vue&type=template&id=34f03cc6"
import script from "./Steps4.vue?vue&type=script&lang=js"
export * from "./Steps4.vue?vue&type=script&lang=js"
script.render = render

export default script